import React, {Component} from "react"
import {connect} from 'react-redux';
import Layout from "../../../components/Layout"
import "./index.scss"

import CustomTable from "../../../components/CustomTableGrid";
//import {columns, rows, headerInformation} from '../../../components/CustomTable/helpers/tableValuesEdit'
import Tooltip from "@material-ui/core/Tooltip";

import {
    rh_get_rows, set_rh, set_comment
} from "../../../store/actions/rh";

import {
    Grid,
    Breadcrumb,
    BreadcrumbItem,
    DataTableSkeleton,
    ComposedModal,
    ModalHeader,
    ModalBody,
    TextArea,
} from "carbon-components-react";

import leng from "../../../data";

import moment from "moment";
import {Chat20, AddComment20} from "@carbon/icons-react";
import ModalComent from "../../../components/ModalComent";


//import data from "../../../data";
const columns = [
    {
        name: 'marca_cod',
        title: 'Código marca',
        editable: false,
        width: 200,
        order: 0,
        height: 38
    },
    {
        name: 'marca_desc',
        title: 'Descrição marca',
        editable: false,
        width: 200,
        order: 1,
        height: 38
    },
    {
        name: 'filial_cod',
        title: 'Código filial',
        editable: false,
        width: 200,
        order: 2,
        height: 38
    },
    {
        name: 'filial_nome',
        title: 'Nome loja',
        editable: false,
        width: 200,
        order: 3,
        height: 38
    },
    {
        name: 'mes_apur',
        title: 'Mês apuração',
        editable: false,
        width: 200,
        order: 4,
        height: 38
    },
    {
        name: 'matricula',
        title: 'Matrícula',
        editable: false,
        width: 200,
        order: 5,
        height: 38
    },
    {
        name: 'nome',
        title: 'nome',
        editable: false,
        width: 400,
        order: 6,
        height: 38
    },
    {
        name: 'cpf',
        title: 'cpf',
        editable: false,
        width: 200,
        order: 7,
        height: 38
    },
    {
        name: 'cargo_cod',
        title: 'Código cargo',
        editable: false,
        width: 200,
        order: 8,
        height: 38
    },
    {
        name: 'cargo_nome',
        title: 'Código nome',
        editable: false,
        width: 200,
        order: 9,
        height: 38
    },
    /*{
        name: 'afastamento_inicio_data',
        title: 'Inicio afast.',
        editable: false,
        width: 200,
        order: 9,
        height: 38
    },
    {
        name: 'afastamento_retorno_data',
        title: 'Fim afast.',
        editable: false,
        width: 200,
        order: 9,
        height: 38
    },*/
    {
        name: 'datas_afastamento',
        title: 'Afastamento(s)',
        editable: false,
        width: 400,
        order: 9,
        height: 38
    },
    {
        name: 'vendas_adicionais',
        title: 'Vendas adic lojas ',
        editable: true,
        width: 200,
        order: 10,
        height: 38
    },
    {
        name: 'dias_media',
        title: 'Dias média',
        editable: true,
        width: 200,
        order: 11,
        height: 38
    },
    {
        name: 'result_qtde_servico',
        title: 'Result. Qtde Serviços',
        editable: true,
        width: 200,
        order: 12,
        height: 38
    },
    {
        name: 'result_desafio_mensal',
        title: 'Result. Desafio Mensal',
        editable: true,
        width: 200,
        order: 13,
        height: 38
    },
    {
        name: 'vendas_servicos',
        title: 'Result. Vendas Serviços',
        editable: true,
        width: 200,
        order: 14,
        height: 38
    },
    {
        name: 'comentario',
        title: 'Comentários',
        editable: false,
        comment: true,
        width: 200,
        order: 15,
        height: 38
    },

];

const columns_no_edit = [
    {
        name: 'marca_cod',
        title: 'Código marca',
        editable: false,
        width: 200,
        order: 0,
        height: 38
    },
    {
        name: 'marca_desc',
        title: 'Descrição marca',
        editable: false,
        width: 200,
        order: 1,
        height: 38
    },
    {
        name: 'filial_cod',
        title: 'Código filial',
        editable: false,
        width: 200,
        order: 2,
        height: 38
    },
    {
        name: 'filial_nome',
        title: 'Nome loja',
        editable: false,
        width: 200,
        order: 3,
        height: 38
    },
    {
        name: 'mes_apur',
        title: 'Mês apuração',
        editable: false,
        width: 200,
        order: 4,
        height: 38
    },
    {
        name: 'matricula',
        title: 'Matrícula',
        editable: false,
        width: 200,
        order: 5,
        height: 38
    },
    {
        name: 'nome',
        title: 'nome',
        editable: false,
        width: 400,
        order: 6,
        height: 38
    },
    {
        name: 'cpf',
        title: 'cpf',
        editable: false,
        width: 200,
        order: 7,
        height: 38
    },
    {
        name: 'cargo_cod',
        title: 'Código cargo',
        editable: false,
        width: 200,
        order: 8,
        height: 38
    },
    {
        name: 'cargo_nome',
        title: 'Código nome',
        editable: false,
        width: 200,
        order: 9,
        height: 38
    },
    /*{
        name: 'afastamento_inicio_data',
        title: 'Inicio afast.',
        editable: false,
        width: 200,
        order: 9,
        height: 38
    },
    {
        name: 'afastamento_retorno_data',
        title: 'Fim afast.',
        editable: false,
        width: 200,
        order: 9,
        height: 38
    },*/
    {
        name: 'datas_afastamento',
        title: 'Afastamento(s)',
        editable: false,
        width: 400,
        order: 9,
        height: 38
    },
    {
        name: 'vendas_adicionais',
        title: 'Vendas adic lojas ',
        editable: false,
        width: 200,
        order: 10,
        height: 38
    },
    {
        name: 'dias_media',
        title: 'Dias média',
        editable: false,
        width: 200,
        order: 11,
        height: 38
    },
    {
        name: 'result_qtde_servico',
        title: 'Result. Qtde Serviços',
        editable: false,
        width: 200,
        order: 12,
        height: 38
    },
    {
        name: 'result_desafio_mensal',
        title: 'Result. Desafio Mensal',
        editable: false,
        width: 200,
        order: 13,
        height: 38
    },
    {
        name: 'vendas_servicos',
        title: 'Result. Vendas Serviços',
        editable: false,
        width: 200,
        order: 14,
        height: 38
    },
    {
        name: 'comentario_no_edit',
        title: 'Comentários',
        editable: false,
        comment: true,
        width: 200,
        order: 15,
        height: 38
    },

];

class Edit extends Component {

    state = {
        rf_mes_edit: "",

        form: {
            modal_comentario: false,
            matricula: "",
            nome: "",
            id_comentario: "",
            comentario: ""
        }
    };

    async componentDidMount() {
        try {
            await this.props.fetchData({
                'filial_name': this.props.match.params.filial
            });
        } catch (e) {
            console.error(e);
        }
    }

    async saveRh(object) {
        await this.props.fetchSetData(object).then(data => {
            this.handleLoadingTabela();
        }).then(data => {
            this.setState({modal_save: true})
        }).catch(err => {
            return false;
        });
    }

    async saveComment(comment) {
        this.setState(prevState => ({
            form: {...prevState.form, modal_comentario: false}
        }))
        await this.props.fetchSetComment({
            _id: comment.id_comentario,
            comentario: comment.comentario
        }).then(data => {
            this.handleLoadingTabela();
        }).then(data => {
            this.setState({modal_save: true})
        }).catch(err => {
            return false;
        });
    }

    handleLoadingTabela = async (e) => {
        await this.props.fetchData({
            'filial_name': this.props.match.params.filial
        }).then(data => {
            return true;
        }).catch(err => {
            return false;
        })
    };

    onCloseModal = e => {
        this.setState(prevState => ({
            form: {...prevState.form, modal_comentario: false}
        }));
    };


    render() {

        let {data, isLoading} = this.props;
        let dataCorrente;
        let filial_name;
        let zero = 0;
        if (!isLoading) {
            var date = new Date();
            if (process.env.REACT_APP_EDIT_AUX_DATA_CORRENTE === 'true') {
                var firstLim = date.getMonth()
            }else{
                var firstLim = date.getMonth() - 1
            }
            var firstDay = new Date(date.getFullYear(), firstLim, 1);
            dataCorrente = moment(firstDay).format("MM / YYYY");
            filial_name = this.props.match.params.filial;
        }
        const callApi = (unmutableRows, object) => this.saveRh(unmutableRows, object);
        const callComments = (matricula, nome, id, comentario) => {
            this.setState({
                form: {
                    matricula: matricula,
                    nome: nome,
                    id_comentario: id,
                    comentario: comentario,
                    modal_comentario: true
                },
            });
        };
        let rows =
            data?.length > 0
                ? data.map(execution => {
                    return {
                        ...execution,
                        id: execution._id,
                        cpf: execution.cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2}|\d{1})/, "$1.***.****-$4"),
                        parentId: null,
                        mes_apur: moment(execution.mes_apur).format("MMM / YYYY"),
                        //afastamento_inicio_data: execution.afastamento_inicio_data === "" ? " - " : moment(execution.afastamento_inicio_data).format("DD/MM/yyyy"),
                        // afastamento_retorno_data: execution.afastamento_retorno_data === "" ? " - " : moment(execution.afastamento_retorno_data).format("DD/MM/yyyy"),
                        datas_afastamento: execution.datas_afastamento,
                        vendas_adicionais: execution.vendas_adicionais === "" ? zero.toFixed(2) : execution.vendas_adicionais.toFixed(2),
                        vendas_servicos: execution.vendas_servicos === "" ? zero.toFixed(2) : execution.vendas_servicos.toFixed(2),
                        result_qtde_servico: execution.result_qtde_servico === "" ? zero.toFixed(2) : execution.result_qtde_servico.toFixed(2),
                        dias_media: execution.dias_media === "" ? zero.toFixed(2) : execution.dias_media.toFixed(2),
                        result_desafio_mensal: execution.result_desafio_mensal === "" ? zero.toFixed(2) : execution.result_desafio_mensal.toFixed(2),
                        type: "row",
                        comentario_no_edit : <div>
                            <AddComment20 size="small" />
                        </div>,
                        comentario: execution.comentario !== "" ?
                            <div>
                                <Tooltip style={{maxWidth: "50px"}} title={execution.comentario.substr(0, 50) + "..."}
                                         arrow>
                                    <Chat20 size="small" style={{cursor: 'pointer', color: "#000"}}
                                            onClick={(e) => callComments(execution.matricula, execution.nome, execution._id, execution.comentario)}/>
                                </Tooltip>
                            </div>
                            :
                            <div>
                                <AddComment20 size="small" style={{cursor: 'pointer', color: "#000"}}
                                              onClick={(e) => callComments(execution.matricula, execution.nome, execution._id, execution.comentario)}/>
                            </div>

                    };
                })
                : [];

        let columns_table = (process.env.REACT_APP_EDIT_AUX_PADRAO.includes(localStorage.getItem('type_user_aux_padrao'))) ? columns : columns_no_edit;
        return (
            <Layout>
                <ModalComent form={this.state.form}
                             onSubmitForm={(data) => this.saveComment(data)}
                             onCloseModal={(data) => this.onCloseModal(data)}

                />
                <Grid class="painel" fullWidth>
                    <div className="container-fluid">
                        <div className="header-text header-text-report">
                            <h5>{leng.sideBar.intelligentJourney.title}</h5>
                            <h3>Auxiliar Padrão</h3>
                            <Breadcrumb noTrailingSlash>
                                <BreadcrumbItem style={{color: "#000000"}}
                                                href="/ij/rh"
                                >Filtering</BreadcrumbItem>
                            </Breadcrumb>
                        </div>
                        <>
                            {isLoading ? (
                                <div style={{paddingTop: "30px", paddingRight: "20px", marginBottom: "50px"}}>
                                    <DataTableSkeleton/>
                                </div>
                            ) : (
                                <>
                                    {this.state.modal_save && (
                                        <ComposedModal size="xs" open preventCloseOnClickOutside
                                                       onClose={() => this.setState({modal_save: false})}>
                                            <ModalHeader title="Status"/>
                                            <ModalBody>
                                                Salvo com sucesso!
                                            </ModalBody>
                                        </ComposedModal>
                                    )}
                                    <div style={{
                                        paddingTop: "30px",
                                        paddingRight: "20px",
                                        marginBottom: "50px"
                                    }}>
                                        <CustomTable headerInformation={{
                                            "title": filial_name,
                                            "date": dataCorrente
                                        }}
                                                     unmutableRows={rows}
                                                     columns={columns_table}
                                                     rowsData={rows}
                                                     editable={true}
                                                     refreshData={callApi}
                                                     callComments={callComments}
                                                     undoData={this.handleLoadingTabela}
                                        />
                                    </div>
                                </>
                            )}
                        </>

                    </div>
                </Grid>
            </Layout>
        )
    }
}

const
    mapStateToProps = ({rh}) => rh;

const
    mapDispatchToProps = dispatch => ({
        fetchData: (filtros) => dispatch(rh_get_rows(filtros)),
        fetchSetData: (rows) => dispatch(set_rh(rows)),
        fetchSetComment: (comment) => dispatch(set_comment(comment)),
    });

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Edit);
